import * as React from "react";
import type { SVGProps } from "react";
const SvgNavMonitor = (props: SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}><path fill="none" d="M0 0h24v24H0V0z" /><path fillOpacity={0.3} d="M2 22h20V2L2 22z" /><path d="M12 12L2 22h10V12z" /></svg>;
export default SvgNavMonitor;